<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="采购单号">
                        <el-input v-model="searchForm.orderNo" placeholder="请输入采购单号"></el-input>
                    </el-form-item>

                    <el-form-item label="食材名称">
                        <el-input v-model="searchForm.materialName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="供应商">
                        <el-input v-model="searchForm.supplier" placeholder="请输入供应商"></el-input>
                    </el-form-item> -->

                    <el-form-item>
                        <el-button type="primary" @click="getPurchaseList()" icon="el-icon-search">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="paginatedPurchaseList" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" height="70vh">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="orderNo" label="订单号" align="center" />
                    <el-table-column prop="materialName" label="食材名称" align="center" />
                    <!-- <el-table-column prop="materialType" label="食材类别" align="center">
                        <template #default="scope">
                            <span>{{ formatType(scope.row.materialType) }}</span>
                        </template>
</el-table-column> -->
                    <el-table-column prop="num" label="采购数量" align="center" />
                    <el-table-column prop="unit" label="单位" align="center" />

                    <el-table-column prop="unitPrice" label="单价(元)" align="center" />
                    <el-table-column prop="totalPrice" label="总金额(元)" align="center" />
                    <el-table-column prop="supplier" label="供应商" align="center" />
                    <!-- <el-table-column prop="room" label="功能间" align="center" /> -->
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="filteredTotalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getRecord } from "@/api/procurement";

export default {
    name: 'PurchaseManagement',
    data() {
        return {
            // 搜索表单
            searchForm: {
                orderNo: '',        // 采购单号
                materialName: '',   // 食材名称
                supplier: '',       // 供应商
            },
            // 原始采购单列表（所有数据）
            purchaseList: [],
            // 食材列表
            materialList: [],
            // 供应商列表
            supplierList: [],
            // 统计数据
            pendingCount: 0,
            approvedCount: 0,
            completedCount: 0,
            monthTotalAmount: 0,
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            // 弹窗状态
            purchaseDialogVisible: false,
            detailDialogVisible: false,
            approvalDialogVisible: false,
            // 详情表单数据
            detailForm: {},
            // 审批表单数据
            approvalForm: {
                id: '',
                purchaseNo: '',
                materialName: '',
                purchaseNum: 0,
                unit: '',
                totalPrice: 0,
                approvalResult: 'approved',
                approvalOpinion: ''
            }
        }
    },
    computed: {
        // 第一步：筛选数据（纯计算，无副作用）
        filteredPurchaseList() {
            // 复制原始数据
            let filtered = [...this.purchaseList];

            // 采购单号筛选
            if (this.searchForm.orderNo) {
                filtered = filtered.filter(item =>
                    item.orderNo && item.orderNo.includes(this.searchForm.orderNo)
                );
            }

            // 食材名称筛选
            if (this.searchForm.materialName) {
                filtered = filtered.filter(item =>
                    item.materialName && item.materialName.includes(this.searchForm.materialName)
                );
            }

            // 供应商筛选
            if (this.searchForm.supplier) {
                filtered = filtered.filter(item =>
                    item.supplier && item.supplier.includes(this.searchForm.supplier)
                );
            }

            // 只返回筛选结果，不修改任何状态
            return filtered;
        },

        // 第二步：获取筛选后的总数量（纯计算）
        filteredTotalCount() {
            return this.filteredPurchaseList.length;
        },

        // 第三步：分页处理（纯计算）
        paginatedPurchaseList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredPurchaseList.slice(start, end);
        }
    },
    watch: {
        // 监听搜索条件变化，重置页码
        searchForm: {
            deep: true,
            handler() {
                this.currentPage = 1;
            }
        }
    },
    mounted() {
        // 页面加载时获取数据
        this.getPurchaseList();
    },
    methods: {
        // 获取采购单列表
        getPurchaseList() {
            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: '正在加载数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            // 调用接口获取数据
            getRecord().then(response => {
                console.log('接口返回数据：', response);
                this.purchaseList = response.data || [];
                loading.close();
            }).catch(error => {
                console.error('获取采购单列表失败：', error);
                this.$message.error('获取数据失败，请稍后重试');
                this.purchaseList = [];
                loading.close();
            });
        },

        // 格式化类别显示
        formatType(type) {
            const typeMap = {
                'vegetable': '蔬菜类',
                'meat': '肉类',
                'seafood': '水产类',
                'grainOil': '粮油类',
                'driedGoods': '干货类'
            };
            return typeMap[type] || type;
        },

        // 重置搜索
        resetSearch() {
            this.searchForm = {
                orderNo: '',
                materialName: '',
                supplier: '',
            };
            this.currentPage = 1;
            // 可选：重新从接口获取数据
            // this.getPurchaseList();
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 重置页码为1
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        // 表格行点击事件
        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

.el-descriptions-item__label {
    font-weight: bold !important;
    background-color: #f5f7fa !important;
}

/* 统计卡片样式 */
.stat-card {
    border-radius: 6px;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.stat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #606266;
}

.stat-content {
    display: flex;
    align-items: baseline;
    margin-top: 15px;
}

.stat-value {
    font-size: 28px;
    font-weight: bold;
    color: #1890ff;
}

.stat-unit {
    margin-left: 5px;
    color: #606266;
}

/* 表单状态信息样式 */
.form-status-info {
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.status-label {
    display: inline-block;
    margin-right: 10px;
    color: #606266;
}

.approval-opinion {
    display: block;
    margin-top: 8px;
    color: #606266;
}

/* 确保弹窗层级正确 */
::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}
</style>